import { Fragment, ReactNode } from "react";
import { Row, Col, Button, Typography, Spin } from "antd";
import "./table-info.scss";
import { Can, Subjects } from "@shared/lib/casl";
import { TableInfoType } from "../types";

const { Title } = Typography;

interface ITableInfo {
  tabs: TableInfoType[];
  name?: string;
  editionalName?: string;
  businessEntity?: Subjects;
  isButton?: boolean;
  buttonName?: string;
  handleIsButton?: () => void;
  children?: ReactNode;
  id?: string;
  isLoading?: boolean;
}

export const TableInfo = ({
  tabs,
  name,
  editionalName,
  isButton,
  buttonName,
  handleIsButton,
  businessEntity,
  children,
  id,
  isLoading,
}: ITableInfo) => {
  const renderEditButton = () => {
    if (!isButton || !handleIsButton) {
      return null;
    }

    const button = (
      <Button
        onClick={handleIsButton}
        type="default"
        style={{ backgroundColor: "#EAEEF8" }}
      >
        {buttonName || "Редактировать"}
      </Button>
    );

    if (businessEntity) {
      return (
        <Can I="edit" a={businessEntity}>
          {button}
        </Can>
      );
    }

    return button;
  };

  return (
    <Spin spinning={isLoading}>
      <div className="table-container" id={id || ""}>
        {name ? (
          <div className="flex-between">
            <Title className="table-info-title" level={4}>
              {name}
            </Title>
            {renderEditButton()}
          </div>
        ) : null}
        {editionalName ? (
          <div className="table-info-subtitle">
            {editionalName}
          </div>
        ) : null}
        <Row gutter={[16, 16]}>
          {children}
          {tabs.map(({ id, title, info }) => (
            <Fragment key={id}>
              <Col span={8} style={{ color: "#888888", lineHeight: "20px" }}>
                {title}
              </Col>
              <Col
                span={16}
                className="table-info-content"
                style={{ lineHeight: "20px" }}
              >
                {info}
              </Col>
            </Fragment>
          ))}
        </Row>
      </div>
    </Spin>
  );
};
